// extracted by mini-css-extract-plugin
module.exports = {"mainScreen":"styles_mainScreen__-hLw1"};